import { gql } from '@apollo/client'

export const CREATE_REVIEW_MUTATION = gql`
  mutation CreateCustomerReview($bookingId: ID!, $rating: Int!, $comment: String) {
    createReview(input: { bookingId: $bookingId, rating: $rating, comment: $comment }) {
      review {
        id
        rating
        comment
        createdAt
      }
      errors
    }
  }
`

export interface CreatedReview {
  id: string
  rating: number
  comment: string | null
  createdAt: string
}

export interface CreateReviewData {
  createReview: {
    review: CreatedReview | null
    errors: string[]
  }
}

export interface CreateReviewVariables {
  bookingId: string
  rating: number
  comment?: string
}
